export default __webpack_public_path__ + "static/media/logo.d5415a17.jpeg";